<template>
  <div
    class="lista-contatos border-right p-2 d-flex flex-column"
    style="width: 140px;"
  >
    <div class="text-right mb-2">
      <b-button
        size="sm"
        variant="outline-danger"
        @click="$emit('fecharSidebar')"
      >
        ←
      </b-button>
    </div>

    <div
      v-for="contato in contatos"
      :key="contato.id"
      class="contato py-2 px-1 mb-1 rounded cursor-pointer"
      :class="{ 'bg-light': selecionado && contato.id === selecionado.id }"
      @click="selecionar(contato)"
    >
      {{ contato.nome }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['usuarioLogado'],
  data() {
    return {
      selecionado: null,
      contatos: [],
    }
  },
  mounted() {
    this.contatos = [
      { id: 'grupo_todos', nome: 'Todos', tipo: 'grupo' },
      { id: 'grupo_suporte', nome: 'Suporte', tipo: 'grupo' },
      { id: 2, nome: 'Fernanda', tipo: 'individual' },
      { id: 3, nome: 'Carlos', tipo: 'individual' },
    ]
  },
  methods: {
    selecionar(contato) {
      this.selecionado = contato
      this.$emit('selecionar', contato)
    },
  },
}
</script>

  <style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  </style>
